import {
  Flame, Target, Gauge, Zap, Rocket, Layers, Grid3x3, Crown, Users, Gift, Lock,
} from "lucide-react";

const ICONS = { Flame, Target, Gauge, Zap, Rocket, Layers, Grid3x3, Crown, Users, Gift };

const CATEGORY_COLOR = {
  streak: "text-orange-500 bg-orange-500/10 border-orange-500/30",
  volume: "text-primary bg-primary/10 border-primary/30",
  rating: "text-blue-400 bg-blue-500/10 border-blue-500/30",
  mastery: "text-purple-400 bg-purple-500/10 border-purple-500/30",
  community: "text-secondary bg-secondary/10 border-secondary/30",
};

export const AchievementBadge = ({ badge, size = "md" }) => {
  const Icon = ICONS[badge.icon] || Target;
  const box = size === "sm" ? "w-10 h-10" : "w-14 h-14";
  const glyph = size === "sm" ? "w-5 h-5" : "w-7 h-7";
  const tone = badge.earned
    ? CATEGORY_COLOR[badge.category] || CATEGORY_COLOR.volume
    : "text-muted-foreground bg-muted/40 border-border";

  return (
    <div
      className={`${box} flex items-center justify-center border ${tone} transition-colors`}
      title={badge.title}
      data-testid={`achievement-icon-${badge.badge_id}`}
    >
      {badge.earned ? <Icon className={glyph} /> : <Lock className={glyph} />}
    </div>
  );
};

export default AchievementBadge;
